package com.macrofocus.common.collection

actual typealias ConcurrentHashSet<K> = HashSet<K>

actual fun <K> emptyConcurrentHashSet(): ConcurrentHashSet<K> {
    return ConcurrentHashSet()
}